import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap'

import styles from './ButtonTiny.scss'

export const ButtonTiny = (props) => {
    const className = classNames(styles.base, styles[`base__${props.type}`], {
        [styles.disabled]: props.disabled,
    })
    return (
        <button
            className={className}
            onClick={props.disabled ? null : props.handleClick}
            onMouseDown={props.disabled ? null : sendClickSoundCommand}
            onMouseEnter={props.disabled ? null : sendHoverSoundCommand}
        >
            <span className={styles.icon}>{props.children}</span>
        </button>
    )
}

ButtonTiny.propTypes = {
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(['default', 'secondary']),
    children: PropTypes.node.isRequired,
    handleClick: PropTypes.func.isRequired,
}

ButtonTiny.defaultProps = {
    type: 'default',
}

export default ButtonTiny



// WEBPACK FOOTER //
// ./components/ButtonTiny/ButtonTiny.jsx